

































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Enums/Data
import { TaxTagBaseTypesMap, TaxTagBaseTypes } from "@/data/enums/tax";
import { DataModules } from "@/store/modules/data";

// Types
import { ITaxTag } from "@/models/tax";
import { ISortableOptions } from "@/models/reordering";

@Component({
  components: {
    "tax-tag-grid-item": () =>
      import("@/components/app/global/tax/tags/taxTagsGridItem.vue"),
    "tax-tag-locations": () =>
      import("@/components/app/global/tax/tags/taxTagLocations.vue")
  }
})
export default class TaxTagsSortableGrid extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public value!: ITaxTag[];

  // Variables
  public sortableOptions: ISortableOptions = {
    chosenClass: "dragged-vessel",
    handle: ".vessel-draggable"
  };
  public sortElems: ITaxTag[] = [];
  public savedOrder: ITaxTag[] = [];

  public TaxTagBaseTypesMap = TaxTagBaseTypesMap();
  public TaxTagBaseTypes = TaxTagBaseTypes;

  // Computed

  public get taxTags() {
    return this.value;
  }

  // Methods

  public removeTaxTag(taxTag: ITaxTag) {
    this.$emit(
      "input",
      this.taxTags.filter(i => i.id !== taxTag.id)
    );
  }

  public openEditModal(taxTag: ITaxTag) {
    this.$store.dispatch(`data/${DataModules.TAX_TAGS}/openAddEditModal`, {
      props: {
        taxTagId: taxTag.id
      },
      events: {
        success: (taxTag: ITaxTag) => {
          this.$emit("refreshData");
          this.$emit("tagTagUpdated", taxTag);
        }
      }
    });
  }

  public onDragDrop() {
    this.$emit("input", this.sortElems);
    this.$store.dispatch("toast/show", {
      message: this.$t("_.priority_changed")
    });
  }

  // Watch
  @Watch("taxTags", { immediate: true })
  public updateSortableData() {
    this.sortElems = this.$_.cloneDeep(this.taxTags);
    this.savedOrder = this.$_.cloneDeep(this.sortElems);
  }
}
